import { chartColors } from '../../../Common/Charts/enums/chart-colors.enum';

/* eslint-disable @typescript-eslint/naming-convention */
export const socialNetworkTypeColorMap = {
    'TWEET': chartColors.agprX,
    'TWITTER': chartColors.agprX,
    'TWITTER_LABEL': chartColors.agprText,
    'FACEBOOK': chartColors.agprFacebook,
    'FACEBOOK_LABEL': chartColors.agprText,
    'INSTAGRAM': chartColors.agprInstagram,
    'INSTAGRAM_LABEL': chartColors.agprText,
    'YOUTUBE': chartColors.agprYoutube,
    'YOUTUBE_LABEL': chartColors.agprText,
    'REDDIT': chartColors.agprReddit,
    'REDDIT_LABEL': chartColors.agprText,
    'TIKTOK': chartColors.agprTiktok,
    'TIKTOK_LABEL': chartColors.agprText,
    'LINKEDIN': chartColors.agprLinkedIn,
    'LINKEDIN_LABEL': chartColors.agprText,
    'BLUESKY': chartColors.agprBluesky,
    'BLUESKY_LABEL': chartColors.agprText,
};
